export default __webpack_public_path__ + "static/logo-eu-a9a0aac6aff5a560a0a93e0d7b4227ac.jpg";